<script lang="ts">
  import { beforeUpdate, createEventDispatcher, onMount } from 'svelte'
  import { Loader } from '@googlemaps/js-api-loader'
  import { loaderOptions } from '$lib/google'
  import type { CustomPlace } from '$lib/types'
  import { browser } from '$app/environment'
  import { getIslandFromUrlPath } from '$lib/helpers'

  export let id: string
  export let name: string | undefined
  export let placeholder: string | undefined
  export let value: CustomPlace | undefined
  export let required = false
  let className: string | undefined
  export { className as class }
  export let sessionToken: google.maps.places.AutocompleteSessionToken
  export let bounds: [[number, number], [number, number]] = [
    [27.55, -18.25],
    [29.5, -13.35]
  ]

  let selectedLocationName = ''
  let autocompleteService: google.maps.places.AutocompleteService
  let placesService: google.maps.places.PlacesService
  let debounceTimer: number
  let predictions: google.maps.places.AutocompletePrediction[] = []
  let firstLoad = false

  onMount(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Loader(loaderOptions as any).load().then(() => {
      let bottomLeftBoundingBoxCoords = new google.maps.LatLng(...bounds[0])
      let upperRightBoundingBoxCoords = new google.maps.LatLng(...bounds[1])

      if (browser && location.pathname.includes('traslados')) {
        const island = getIslandFromUrlPath(location.pathname)
        if (island) {
          bottomLeftBoundingBoxCoords = new google.maps.LatLng(...island.boundingBox[0] as [number, number])
          upperRightBoundingBoxCoords = new google.maps.LatLng(...island.boundingBox[1] as [number, number])
        }
      }

      const locationRestriction = new google.maps.LatLngBounds(bottomLeftBoundingBoxCoords, upperRightBoundingBoxCoords)
      const autocompleteOptions: google.maps.places.AutocompletionRequest = {
        input: '',
        componentRestrictions: { country: 'es' },
        locationRestriction,
        sessionToken
      }

      const inputElement = document.getElementById(id) as HTMLInputElement
      autocompleteService = new google.maps.places.AutocompleteService()
      placesService = new google.maps.places.PlacesService(document.createElement('div'))

      inputElement.addEventListener('input', function () {
        const inputValue = inputElement.value
        selectedLocationName = inputValue

        if (inputValue.length > 4) {
          clearTimeout(debounceTimer)
          debounceTimer = window.setTimeout(() => {
            autocompleteOptions.input = inputValue
            autocompleteService.getPlacePredictions(autocompleteOptions, (predictionsResult, status) => {
              if (status === google.maps.places.PlacesServiceStatus.OK && predictionsResult) {
                predictions = predictionsResult
                //  return  some !predictionResult.contains(premise , geocoding) esto viene de que he estado mirando los places y los tipos que devuelve gmaps y hay veces que en aeropuerto esta devolviendo tipo premise
                //  y geocode según he investigado es que esta devolviendo el edificio como place y no lo pone como aeropuerto porque lo cuenta como un lugar
                //   dentro de el aunque el nombre sea aeropuerto gran canaria
              } else {
                predictions = []
              }
            })
          }, 700)
        } else {
          predictions = []
        }
      })
    })
  })
  beforeUpdate(() => {
    if (value && !selectedLocationName && !firstLoad) {
      selectedLocationName = value?.name as string
      firstLoad = true
    }
  })
  const dispatch = createEventDispatcher()

  function selectPrediction(prediction: google.maps.places.AutocompletePrediction) {
    selectedLocationName = prediction.description
    getPlaceDetails(prediction.place_id)
    predictions = []
  }

  async function getPlaceDetails(placeId: string) {
    const result = await fetchPlaceFromServer(placeId)
    if (result) {
      const customPlace: CustomPlace = {
        googleId: result.google_id ? result.google_id : '',
        name: result.name ? result.name : '',
        coordinates: {
          lat: result.coordinates.lat ?? 0,
          lng: result.coordinates.lng ?? 0
        }
      }
      dispatch('placeSelected', customPlace)
    } else {
      placesService.getDetails({ placeId, fields: ['place_id', 'name', 'geometry.location'] }, async (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && result) {
          const customPlace: CustomPlace = {
            googleId: result.place_id ? result.place_id : '',
            name: result.name ? result.name : '',
            coordinates: {
              lat: result.geometry?.location?.lat() ?? 0,
              lng: result.geometry?.location?.lng() ?? 0
            }
          }
          await savePlaceToServer(customPlace)
          value = customPlace
          selectedLocationName = customPlace.name
          dispatch('placeSelected', customPlace)
        }
      })
    }
  }
  async function fetchPlaceFromServer(googleId: string): Promise<any | null> {
    try {
      const response = await fetch(`/api/places?googleId=${googleId}`)
      if (!response.ok) return null
      return await response.json()
    } catch (error) {
      console.error('Error fetching place from server:', error)
      return null
    }
  }
  async function savePlaceToServer(place: CustomPlace): Promise<void> {
    try {
      await fetch('/api/places', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(place)
      })
    } catch (error) {
      console.error('Error saving place to server:', error)
    }
  }
</script>

<input
  {id}
  {name}
  {required}
  {placeholder}
  bind:value={selectedLocationName}
  type="text"
  autocomplete="off"
  on:keydown={(event) => event.key === 'Enter' && event.preventDefault()}
  class={className}
/>

{#if predictions.length > 0}
  <ul class="absolute z-50 bg-white border border-gray-300 shadow-lg top-full left-0 w-80 max-h-80 overflow-y-auto rounded-md">
    {#each predictions as prediction}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
      <li
        class="px-4 py-2 cursor-pointer text-sm border-b border-gray-200 hover:bg-gray-100 last:border-b-0"
        on:click={() => selectPrediction(prediction)}
      >
        {prediction.description}
      </li>
    {/each}
  </ul>
{/if}
